import { createFileRoute } from '@tanstack/react-router';

import { ModulePlaceholder } from '../components/module-placeholder';
import { requireOnboarding } from '../features/onboarding/require-onboarding';
import { MODULE_INTRO } from '../lib/module-intro';

export const Route = createFileRoute('/flow')({
  beforeLoad: ({ context, location }) =>
    requireOnboarding({ queryClient: context.queryClient, location }),
  component: () => <ModulePlaceholder {...MODULE_INTRO.flow} />,
});
